import application from 'application/application';

const controller = 'DefaultAccountPlansController';

application

	.controller(controller, [() => {}]);

export default controller;
